export default __webpack_public_path__ + "resources/icons/n500-d98f.png";